import * as React from "react";
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  DateField,
  TextField,
  NumberField,
  EditButton,
  TextInput,
  DateInput,
  Title,
  EditActions,
  FormTab,
  required,
  SelectInput,
  TabbedForm,
  DeleteWithConfirmButton,
  SaveButton,
  Toolbar,
  NumberInput,
  SearchInput,
} from "react-admin";
import BookIcon from "@material-ui/icons/Book";
export const PostIcon = BookIcon;

const advanceFilter = [
  <TextInput source="accountId" />,
  // <DateInput
  //   source="date"
  //   // format={(record: Date) => {
  //   //   if (!(record instanceof Date)) return;
  //   //   console.log("--->  ", record);
  //   //   return record.getTime();
  //   // }}
  // />,
];

export const AdvanceList = (props: any) => {
  return (
    <List {...props} filters={advanceFilter}>
      <Datagrid>
        <NumberField source="id" />
        <NumberField source="accountId" />
        <NumberField source="advance" locales="en-GB" />
        <NumberField source="maximumAdvance" locales="en-GB" />
        <DateField source="date" locales="en-GB" />
        {/* <NumberField source="status" />
        <NumberField source="type" /> */}
        <EditButton />
      </Datagrid>
    </List>
  );
};

const UserEditToolbar = (props: any) => {
  return (
    <Toolbar {...props}>
      <SaveButton disabled={props.invalid} onClick={() => {}} />
      <DeleteWithConfirmButton onClick={() => {}} onFailure={(error) => {}} />
    </Toolbar>
  );
};

const UserEditForm = (props: any) => {
  const newSave = (values: any) => props.save(values);

  return (
    <SimpleForm
      defaultValue={{ role: "user" }}
      toolbar={<UserEditToolbar />}
      {...props}
      save={newSave}
    >
      <NumberInput source="id" validate={required()} disabled />
      <NumberInput source="accountId" />
      <NumberInput source="advance" />
      <DateInput source="date" />
      <NumberInput source="status" />
      <NumberInput source="type" />
    </SimpleForm>
  );
};

export const AdvanceEdit = (props: any) => {
  return (
    <Edit title="Edit single entry" actions={<EditActions />} {...props}>
      <UserEditForm permissions={props.permissions} />
    </Edit>
  );
};

const PostCreateToolbar = (props: any) => (
  <Toolbar {...props}>
    <SaveButton label="save" redirect="edit" submitOnEnter={true} />
  </Toolbar>
);

export const AdvanceCreate = (props: any) => {
  return (
    <Create {...props}>
      <SimpleForm toolbar={<PostCreateToolbar />}>
        <NumberInput autoFocus source="accountId" validate={required()} />
        <NumberInput source="advance" validate={required()} />
        <DateInput source="date" validate={required()} />
        <NumberInput source="status" validate={required()} />
        <NumberInput source="type" validate={required()} />
      </SimpleForm>
    </Create>
  );
};
